import React, { CSSProperties, ReactNode } from 'react';

import useDeviceDetect from 'hooks/useDeviceDetect';

import RequiredSpan from '../components/RequiredSpan';
import './Input.scoped.scss';

interface Props {
  name?: string;
  error?: string;
  children?: React.ReactNode;
  style?: CSSProperties;
  containerStyle?: CSSProperties;
  outlined?: boolean;
  label?: string;
  grey?: boolean;
  placeholder?: string;
  desperate?: boolean;
  required?: boolean;
  type: string;
  prependIcon?: string;
  appendIcon?: ReactNode;
  iconPosition?: 'left' | 'right';
  labelStyle?: CSSProperties;
  value?: any; // remember to delete ? when refactor
  onChange: (val: any) => void;
  onKeyDown?: (val: any) => void;
  onIconClicked?: (val: any) => void;
  onBlur?: () => void;
  size?: 'small' | 'normal';
  disabled?: boolean;
}

const Input = React.forwardRef<HTMLInputElement, Props>(
  (
    {
      name,
      onChange,
      onKeyDown,
      onBlur,
      labelStyle,
      containerStyle,
      required,
      onIconClicked,
      appendIcon,
      iconPosition = 'right',
      style,
      outlined = false,
      desperate = false,
      label,
      placeholder,
      grey = false,
      error,
      type,
      value,
      size = 'normal',
      disabled,
    },
    ref
  ) => {
    const leftIcon = iconPosition === 'left';
    const { isMobile } = useDeviceDetect();
    return (
      <div className={`${isMobile && 'mobile'} theme-input`} style={containerStyle}>
        {label && (
          <label style={labelStyle}>
            <RequiredSpan required={required} />
            {label}
          </label>
        )}
        <div className="input-and-icons">
          {appendIcon && leftIcon && (
            <div
              onClick={() => (onIconClicked ? onIconClicked(value) : '')}
              className={`append-icon left pointer ${size && size}-icon`}
            >
              {appendIcon}
            </div>
          )}

          <input
            disabled={disabled}
            name={name}
            type={type}
            ref={ref}
            className={`${outlined && 'outlined'} ${desperate && 'desperate'} ${grey && 'grey'} ${
              leftIcon && 'left-icon'
            } ${size && size} `}
            style={{ ...style }}
            placeholder={placeholder}
            value={value}
            onChange={({ target: { value } }) => onChange(value)}
            onBlur={onBlur}
            onKeyDown={onKeyDown}
          />

          {appendIcon && !leftIcon && (
            <div
              onClick={() => (onIconClicked ? onIconClicked(value) : '')}
              className={`append-icon right pointer ${size && size}-icon`}
            >
              {appendIcon}
            </div>
          )}
        </div>
        {error && <p className="error-text">{error}</p>}
      </div>
    );
  }
);

export default Input;
